import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
// import UserAuth from "../../../services/UserAuth";
import VerifyPhoneNumber from "../../Layouts/VerifyUser/VerifyPhoneNumber";
import PackagesList from "./PackagesList";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import BrandList from "../../Customer/BrandList";
import SearchUserExistence from "./SearchUserExistence";
import useAuth from "../../../hooks/useAuth";
import {Link} from "react-router-dom";
import {showOtpInAddCustomer} from "../../../configuration/partnerConfig";

let showOtpBlock = false;
if(showOtpInAddCustomer != null){
    showOtpBlock = showOtpInAddCustomer;
}
function AddCustomer(props) {
    const {auth} = useAuth();
    const [customerName, setCustomerName] = useState('');
    const [customerTel, setCustomerTel] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerEVRegNum, setEVRegNum] = useState('');
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [nameMessage, setNameMessage] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [phoneMessage, setPhoneMessage] = useState('');
    const [registrationNumberMessage, setRegistrationNumberMessage] = useState('');
    const [registrationNumberSuccessMessage, setRegistrationNumberSuccessMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [optVerfied, setOptVerfied] = useState(!showOtpBlock);
    const [step, setStep] = useState(0);
    const axiosPrivate = useAxiosIntercept();
    const [selectedBrand, setSelectedBrand] = useState();
    const [selectedModel, setSelectedModel ] = useState();
    const [selectedVariant, setSelectedVariant] = useState();
    const [userId, setUserId] = useState();
    const [vehicleId, setVehicleId] = useState();
    const [brandList, setBrandList] = useState([]);
    const [selectedPackage, setselectedPackage]= useState();
    const [brandMessage, setBrandMessage] = useState("");
    const [modelMessage, setModelMessage] = useState("");
    const [variantMessage, setVariantMessage] = useState("");
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);
    const [selectedCheckBox, setSelectedCheckBox] = useState(0);

    const getUserVehicleDetails = async () =>{
        try{
            const url = process.env.REACT_APP_GET_USER_VEHICLE_LIST_URL +"&search_by=registration_no"+"&search_keyword="+customerEVRegNum;
            const response = await axiosPrivate.get(url);
            if(response?.data?.response){
                if(!response?.data?.response?.data?.total){
                    return (response?.data?.response?.data);
                }
                else{
                    if(response?.data?.response?.data?.user_vehicles[0]?.user_id == userId ){
                        if(auth.is_corporate == response?.data?.response?.data?.user_vehicles[0]?.is_corporate){
                            setSelectedBrand({"id":response?.data?.response?.data?.user_vehicles[0].brand_id,"name": response?.data?.response?.data?.user_vehicles[0].brand_name});
                            setSelectedModel({"id":response?.data?.response?.data?.user_vehicles[0].model_id,"name": response?.data?.response?.data?.user_vehicles[0].model_name});
                            setSelectedVariant({"id":response?.data?.response?.data?.user_vehicles[0].variant_id ,"name": response?.data?.response?.data?.user_vehicles[0].variant_name});
                            setVehicleId(response?.data?.response?.data?.user_vehicles[0].vehicle_id);
                            setRegistrationNumberSuccessMessage("Vehicle Found");
                            setTimeout(()=>{
                                setRegistrationNumberSuccessMessage("");
                                setStep(3);
                            },5000)
                        }
                        else{
                            setRegistrationNumberMessage("Registration number already associated with someone");
                            setTimeout(()=>{
                                setRegistrationNumberMessage("");
                            },5000)
                        }
                    }
                    else{
                        setRegistrationNumberMessage("Registration number already registered");
                        setTimeout(()=>{
                            setRegistrationNumberMessage("");
                        },5000)
                    }

                    return (response?.data?.response?.data);
                }

            } else {
                console.log('something went wrong')
            }
        }
        catch (error){
            console.log(error);
        }
    }

    const userVehicleMap = async () => {
        try{
            const url = process.env.REACT_APP_USER_VEHICLE_REGISTER_URL;
            let payload = {};
            payload.user_id= userId;
            payload.registration_no = customerEVRegNum;
            payload.variant_id = selectedVariant.id;
            if(auth.is_corporate != null){
                payload.is_corporate = auth.is_corporate;
            }
            const response = await axiosPrivate.post(url, payload);
            if(response?.data?.response){
                setVehicleId(response?.data?.response?.data?.vehicle_id);
                return(response?.data?.response?.data?.vehicle_id);
                if(response?.data?.response?.data?.errors[0]){
                    setMessage(response?.data?.response?.data?.errors[0].message);
                    setTimeout(()=>{
                        setMessage("");
                    },5000)
                }
            }
            else{
                console.log('something went wrong')
            }
        }
        catch (error){
            console.log(error);
        }
    }
    const setUserPersonalDetails = (userData, searchValue) =>{
        setUserId('');
        setUserId('');
        setCustomerTel('');
        setCustomerName('');
        setCustomerEmail('');
        if(showOtpBlock){
            setOptVerfied(false);  // when otp is enabled
        }



        setVehicleId();
        setSelectedBrand({});
        setSelectedModel({});
        setSelectedVariant({});
        setEVRegNum('');

        if(userData.length == 0){
            // setCustomerTel(()=>userData[0].phone);
            setStep(1);
            setCustomerTel(searchValue);
        }
        else{
            setUserId(userData[0].user_id);
            setCustomerTel(userData[0].phone);
            setCustomerName(userData[0].firstname +" " +  userData[0].lastname);
            setCustomerEmail(userData[0].email);
            setStep(1);
            setOptVerfied(true);
        }

    }
    const validateEmail = () => {
        let input = customerEmail;
        var validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (input.match(validRegex) || input == "") {
            return true;
        } else {
            setEmailMessage("Email not Valid");
            setTimeout(()=>{
                setEmailMessage("");
            },3000)
            // document.form1.text1.focus();
            return false;
        }
    }


    const increaseStep  = (e) =>{
        if(!isSubmitClicked){
            e.preventDefault();
            setMessage("");
            setNameMessage("");
            setEmailMessage("");
            setPhoneMessage("");
            // if(step ==0 ){
            //     if(customerTel.length==0){
            //         setMessage("Enter Phone Number");
            //         setTimeout(()=>{
            //             setMessage("");
            //         },3000)
            //     }
            // }
            if(step == 1){
                if(validateEmail()){
                    if(optVerfied){
                        if(customerName == ' ' || customerName.length == 0){
                            setNameMessage("Enter Name");
                            setTimeout(()=>{
                                setNameMessage("");
                            },3000)
                        }
                        else {
                            // localStorage.setItem(userData:{name:customerName,})

                            let data = {name: customerName, phone: customerTel, email: customerEmail };
                            if(userId){
                                data = {...data, user_id: userId};
                            }
                            localStorage.setItem("userData",JSON.stringify(data));
                            setStep(prevState => prevState+1);
                        }
                    }
                    else{
                        setPhoneMessage("Verify Phone Number")
                        setTimeout(()=>{
                            setPhoneMessage("");
                        },3000)
                    }
                }
            }
            else if(step == 2){
                if(vehicleId && userId){
                    let value= JSON.parse(localStorage.getItem("userData"));
                    let data = {...value, brand: selectedBrand, model: selectedModel, variant: selectedVariant, registrationNo: customerEVRegNum, vehicleId: vehicleId};
                    localStorage.setItem("userData",JSON.stringify(data));
                    setStep(prevState => prevState+1);
                }
                else{
                    if(customerEVRegNum){
                        if(selectedBrand){
                            if(Object.keys(selectedVariant).length !== 0 && Object.keys(selectedModel).length !== 0){
                                if(userId){
                                    getUserVehicleDetails().then((data)=>{
                                        if(data.total == 0){

                                            let value= JSON.parse(localStorage.getItem("userData"));
                                            let datum = {...value, brand: selectedBrand, model: selectedModel, variant: selectedVariant, registrationNo: customerEVRegNum};
                                            localStorage.setItem("userData",JSON.stringify(datum));
                                            setStep(prevState => prevState+1);
                                        }
                                    });
                                }
                                else{
                                    getUserVehicleDetails().then((data)=>{
                                        if(data.total == 0){

                                            let value= JSON.parse(localStorage.getItem("userData"));
                                            let datum = {...value, brand: selectedBrand, model: selectedModel, variant: selectedVariant, registrationNo: customerEVRegNum};
                                            localStorage.setItem("userData",JSON.stringify(datum));
                                            setStep(prevState => prevState+1);
                                        }

                                    });


                                    // localStorage.setItem({...value, "brand":selectedBrand, "model":selectedModel, "variant":selectedVariant});
                                }

                            }
                            else{
                                if(Object.keys(selectedVariant).length == 0){
                                    setVariantMessage("Select Variant");
                                    setTimeout(()=>{
                                        setVariantMessage("");
                                    },3000);
                                }

                                if(Object.keys(selectedModel).length == 0){
                                    setModelMessage("Select Model");
                                    setTimeout(()=>{
                                        setModelMessage("");
                                    },3000);
                                }

                            }
                        }
                        else{
                            setBrandMessage("Select Brand");
                            setTimeout(()=>{
                                setBrandMessage("");
                            },3000);
                        }

                    }
                    else{
                        setRegistrationNumberMessage("Enter EV Registration Number");
                        setTimeout(()=>{
                            setRegistrationNumberMessage("");
                        },3000)
                    }
                }
            }
            else if(step == 3){
                setMessage("");
                if(selectedCheckBox == 1){
                    if(userId){
                        if(vehicleId){
                            setIsSubmitClicked(true);
                            // mapUserPackage();
                            localStorage.removeItem("userData");
                            navigate("/customers", {state:{message:"Customer added successfully"}});
                        }
                        else{
                            setIsSubmitClicked(true);
                            userVehicleMap().then((data)=>{
                                // mapUserPackage(userId, data);
                                localStorage.removeItem("userData");
                                navigate("/customers", {state:{message:"Customer added successfully"}});
                            })
                        }
                    }
                    else{
                        setIsSubmitClicked(true);
                        addNewCustomer().then((data)=>{
                            // mapUserPackage(data.user_id, data.vehicle_id);
                            localStorage.removeItem("userData");
                            navigate("/customers", {state:{message:"Customer added successfully"}});
                        });
                    }
                }
                else {
                    if (selectedPackage) {
                        if (userId) {
                            if (vehicleId) {
                                setIsSubmitClicked(true);
                                mapUserPackage();
                            } else {
                                setIsSubmitClicked(true);
                                userVehicleMap().then((data) => {
                                    mapUserPackage(userId, data);
                                })
                            }
                        } else {
                            setIsSubmitClicked(true);
                            addNewCustomer().then((data) => {
                                mapUserPackage(data.user_id, data.vehicle_id);
                            });
                        }
                    } else {
                        setMessage("Select a package");
                        setTimeout(() => {
                            setMessage("");
                        }, 3000)
                    }
                }
            }
        }}

    useEffect(()=>{
        let value;
        value= JSON.parse(localStorage.getItem("userData"));
        if(value && value.phone != null){
            setCustomerTel(value.phone);
            setOptVerfied(true);
            setStep(2);
        }
        if(value && value.user_id != null){
            setUserId(value.user_id)
        }
        if(value && value.name != null){
            setCustomerName(value.name);
        }
        if(value && value.email != null){
            setCustomerEmail(value.email);
        }
        if(value && value.brand != null){
            setSelectedBrand(value.brand);
        }
        if(value && value.brand != null){
            setSelectedModel(value.model);
        }
        if(value && value.variant != null){
            setSelectedVariant(value.variant);
        }
        if(value && value.registrationNo != null){
            setEVRegNum(value.registrationNo);
        }
        if(value && value.registrationNo != null && value.variant != null){
            setStep(3);
        }
        // return(()=>{
        //     localStorage.removeItem("userData");
        // })
    },[])

    let opt = (value) => {
        setOptVerfied(value);
        if(value){
            setSelectedBrand('');
            setSelectedModel('');
            setSelectedVariant('');
            setEVRegNum('');
        }
    }

    const mapUserPackage = async (user_id, vehicle_id) => {
        try {
            let payload = {};
            if(user_id){
                payload.customer_user_id = user_id;
            }
            else{
                payload.customer_user_id = userId;
            }
            if(vehicle_id){
                payload.vehicle_id = vehicle_id;
            }
            else{
                payload.vehicle_id = vehicleId;
            }
            payload.package_id = selectedPackage.id;

            const response = await axiosPrivate.post(process.env.REACT_APP_BOOKING_BUY_PACKAGE, payload);
            if(response?.data?.response){
                if(response.data.message){
                    setSuccessMessage(response.data.message);
                    localStorage.removeItem("userData");
                    navigate("/customers", {state:{message:response.data.message}});
                }
            }
            else{
                console.log("something went wrong");
            }
        }
        catch (error){
            console.log(error);
        }
    }
    const addNewCustomer = async () => {
        setMessage('');

        try {
            let payload = {};
            if(customerName != ''){
                payload.name = customerName;
            }
            if(customerTel != '')
                payload.phone = customerTel;
            if(customerEmail != ''){
                payload.email = customerEmail;}
            if(customerEVRegNum != ''){
                payload.registration_no = customerEVRegNum;}
            if(selectedVariant.id != ''){
                payload.variant_id = selectedVariant.id;}


            const res = await axiosPrivate.post( process.env.REACT_APP_ADD_CUSTOMER_URL, payload);
            console.log(res);
            if(res?.data?.response){
                if(res?.data?.response?.data){
                    setUserId(()=>res.data.response.data.user_id);
                    setVehicleId(()=>res.data.response.data.vehicle_id);
                    return (res?.data?.response?.data);
                }
                if(res?.data?.response?.errors){
                    setMessage(res?.data?.response?.errors[0].message);
                    setTimeout(()=>{
                        setMessage("");
                    },5000)
                }

                return res?.data?.response;

            } else {
                console.log('something went wrong')
            }
        }
        catch(err) {
            console.log(err)
        }

    };



    return (
        <div className="rightCol">
            <div className="contentContainer">
                <h2>
                    <Link to="/customers">
                        <span className="material-symbols-rounded mt-l black">arrow_back</span>
                    </Link>
                    Add new customer
                </h2>

                <div className="border radius formSection">
                    <div className="formSteps pad-24">
                        <ul>
                            <li className={step == 1 || step == 0 ? "" : "previous"}>
                                {step == 1 || step == 0 ? <i>1</i> : <i/>}
                                <a href={void(0)} onClick={(e)=>{e.stopPropagation()}}>Personal details</a>
                            </li>
                            <li className={step < 2 ? "next" : (step == 2 ? "" : "previous")}>
                                {step <= 2 ? <i>2</i> : <i/>}
                                <a href={void(0)}>Vehicle details</a>
                            </li>
                            <li className={step < 3 ? "next" :  ""}>
                                {step <= 3 ? <i>3</i> : <i/>}
                                <a href={void(0)}>Package details</a>
                            </li>
                        </ul>
                    </div>
                    <div className="subContent newCustomer pad-24">
                        {step > 1 &&
                            <div className="heading mb-24">
                                {step ==2 &&
                                    <>
                                        <i className="material-symbols-rounded grey mt-s" onClick={()=>setStep(prevState => prevState-1)}>arrow_back_ios_new</i>
                                        <a href={void(0)} onClick={()=>setStep(prevState => prevState-1)}>
                                            Back to personal details
                                        </a>
                                    </>}
                                {step ==3 &&
                                    <>
                                        <i className="material-symbols-rounded grey mt-s" onClick={()=>setStep(prevState => prevState-1)}>arrow_back_ios_new</i>
                                        <a href={void(0)} onClick={()=>setStep(prevState => prevState-1)}>
                                            Back to vehicle details
                                        </a>
                                    </>}
                            </div>
                        }

                        {(step == 0 || step == 1) && <SearchUserExistence PhoneNumber={customerTel} step={step} setUserPersonalDetails={(value, searchvalue)=>setUserPersonalDetails(value, searchvalue)}/>}
                        <div className="dForm w300 mt-24">
                            {(step == 1) && <>

                                {userId ?
                                    <></>
                                    :
                                    <>
                                        {!showOtpBlock ?
                                            <div className="fieldGroup mobileVerfiy">
                                                <label>Phone Number</label>
                                                <span className="mb-12">
                                                        <input
                                                            id="phone_number"
                                                            type="tel"
                                                            name="phone_number"
                                                            required
                                                            maxLength='10'
                                                            disabled={true}
                                                            minLength='8'
                                                            pattern="[0-9]"
                                                            value={customerTel}
                                                            autoComplete="nope"
                                                            // onChange={handlePhoneChange}
                                                            placeholder="Enter Phone Number"
                                                        />
                                                    </span>
                                            </div>
                                            :
                                            <VerifyPhoneNumber message = {(value)=>setMessage(value)} isoptValid={optVerfied} opt={(value)=>{opt(value)}} phone={(value)=>{setCustomerTel(value)}} PhoneNumber={customerTel} disable={true}/>
                                        }
                                        {phoneMessage!="" &&
                                            <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {phoneMessage}
                                                    </span>
                                            </div>
                                        }
                                        {/*<span style={{color:"red"}}> {phoneMessage}</span>*/}
                                    </>
                                }
                                <div className="fieldGroup mt-0">
                                    <label>Customer name</label>
                                    <span>
                                        <input
                                            id="customer_name"
                                            type="text"
                                            name="customer_name"
                                            required
                                            value={customerName}
                                            disabled={userId || step == 0? true : false}
                                            onChange={(e) => {setCustomerName(e.target.value.replace(/[^A-Za-z]+$/ig  , " "))}}
                                            placeholder="Enter Customer Name"
                                        />
                                    </span>

                                </div>
                                {nameMessage!="" &&
                                    <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {nameMessage}
                                                    </span>
                                    </div>
                                }
                                <div className="fieldGroup">
                                    <label>Email</label>
                                    <span>
                                        <input
                                            id="customer_email"
                                            type="email"
                                            name="customer_email"
                                            disabled={userId || step == 0 ? true : false}
                                            onChange={e => setCustomerEmail(e.target.value)}
                                            value={customerEmail}
                                            placeholder="Enter Email ID"
                                        />
                                    </span>

                                </div>
                                {emailMessage != "" &&
                                    <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {emailMessage}
                                                    </span>
                                    </div>
                                }
                            </>}

                            {step == 2 &&
                                <>
                                    <div className="fieldGroup">
                                        <label>EV registration number</label>
                                        <span>
                                            <input
                                                required
                                                id="customer_registrationNo"
                                                type="text"
                                                onChange={e => setEVRegNum(e.target.value)}
                                                name="customer_registrationNo"
                                                value={customerEVRegNum}
                                                disabled={vehicleId ? true : false}
                                                placeholder="Enter Registration Number"
                                            />
                                        </span>
                                    </div>
                                    {registrationNumberMessage!="" &&
                                        <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {registrationNumberMessage}
                                                    </span>
                                        </div>
                                    }

                                    {userId && vehicleId
                                        ?
                                        // <>
                                        //     <div className="fieldGroup">
                                        //         <label>Select EV Brand</label>
                                        //         <div className="multiOption">
                                        //             <div className="selectBox fullW">
                                        //                 <p>{selectedBrand.name}{" "}</p>
                                        //                 {/*<i className="material-symbols-rounded grey">expand more</i>*/}
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        //     <div className="fieldGroup">
                                        //         <label>Select Model & Variant</label>
                                        //         <div className="multiOption">
                                        //             <div className="selectBox fullW">
                                        //                 <p>{selectedModel.name}, {selectedVariant.name}{" "}</p>
                                        //                 {/*<i className="material-symbols-rounded grey">expand more</i>*/}
                                        //             </div>
                                        //         </div>
                                        //     </div>
                                        // </>
                                        <BrandList brandMessage={brandMessage} modelMessage={modelMessage} variantMessage={variantMessage} setBrandList={(value)=>setBrandList(value)} selectedBrand={selectedBrand} setBrand={(value)=>setSelectedBrand(value)}  selectedModel={selectedModel} setModel={(value)=>setSelectedModel(value)} selectedVariant={selectedVariant} setVarint={(value)=>{setSelectedVariant(value)}}/>

                                        :
                                        <BrandList brandMessage={brandMessage} modelMessage={modelMessage} variantMessage={variantMessage} setBrandList={(value)=>setBrandList(value)} selectedBrand={selectedBrand} setBrand={(value)=>setSelectedBrand(value)}  selectedModel={selectedModel} setModel={(value)=>setSelectedModel(value)} selectedVariant={selectedVariant} setVarint={(value)=>{setSelectedVariant(value)}}/>
                                    }
                                    {registrationNumberSuccessMessage!="" &&
                                        <div>
                                            <span className="success">
                                                <span className="material-symbols-rounded success mt-xs fill">
                                                    info
                                                </span>
                                                {registrationNumberSuccessMessage}
                                            </span>
                                        </div>

                                    }
                                </>
                            }
                            {step == 3 &&
                                <>
                                    {
                                        auth.is_corporate == 1 &&
                                        <>
                                            <div className="fieldGroup">
                                                <label>Choose package type </label>
                                                <ul className="yType">
                                                    <li>
                                                        <input
                                                            type="radio"
                                                            id="yTypeCheckbox1"
                                                            name="yTypeCheckbox"
                                                            checked={selectedCheckBox == 0 && "checked"}

                                                        />
                                                        <label
                                                            onClick={()=>{setSelectedCheckBox(0)}}
                                                        >
                                                            Package
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <input
                                                            type="radio"
                                                            id="yTypeCheckbox2"
                                                            name="yTypeCheckbox"
                                                            checked={selectedCheckBox == 1 && "checked"}
                                                        />
                                                        <label
                                                            onClick={()=>{setSelectedCheckBox(1)}}
                                                        >
                                                            Pay as you go
                                                        </label>
                                                    </li>

                                                </ul>
                                            </div>
                                        </>
                                    }
                                    {   selectedCheckBox == 0 &&
                                        <PackagesList  selectedBrandId={selectedBrand.id} selectedModelId={selectedModel.id} selectedVariantId={selectedVariant.id} selectedPackage={selectedPackage} setSelectedPackage={(value)=>{setselectedPackage(value)}}/>
                                    }
                                    {/*<div className="fieldGroup">*/}
                                    {/*    <ul className="yType">*/}

                                    {/*<li>*/}
                                    {/*    <input*/}
                                    {/*        type="radio"*/}
                                    {/*        id="yTypeCheckbox2"*/}
                                    {/*        name="yTypeCheckbox"*/}
                                    {/*        checked={selectedCheckBox == 1 && "checked"}*/}
                                    {/*    />*/}
                                    {/*    <label*/}
                                    {/*        onClick={()=>{setSelectedCheckBox(1)}}*/}
                                    {/*    >*/}
                                    {/*        Pay as you go*/}
                                    {/*    </label>*/}
                                    {/*</li>*/}

                                    {/*    </ul>*/}
                                    {/*</div>*/}

                                </>
                            }

                            {step == 3 ?
                                <div className="actionButtons mt-24">
                                    <span onClick={increaseStep}>
                                        <a href={void(0)} className="btn prim">
                                        Add customer
                                        </a>
                                    </span>
                                </div>
                                :
                                (step != 0 ? <div className="actionButtons mt-24">
                                    <span>
                                        <a href={void(0)} className={step == 0 ? "btn prim disable" : "btn prim"} onClick={increaseStep}>
                                        Next
                                        </a>
                                    </span>
                                </div> : <></>)
                            }
                            {message != "" &&
                                <div>
                                    <span className="error">
                                        <span className="material-symbols-rounded error mt-xs fill">
                                            info
                                        </span>
                                        {message}
                                    </span>
                                </div>}
                            <div style={{color:"green"}}>{successMessage}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddCustomer;